import type { ApiMessage, ApiMessageEditSnapshot } from '../../api/types';

export const MESSAGE_ARCHIVE_DB_KEY = 'rasi-message-archive-v1';
export const MESSAGE_ARCHIVE_VERSION = 1;

export interface ArchivedMessageEntry {
  chatId: string;
  messageId: number;
  snapshot: ApiMessage;
  editHistory?: ApiMessageEditSnapshot[];
  isDeleted?: boolean;
  updatedAt: number;
}

export interface MessageArchiveDatabase {
  version: number;
  entries: Record<string, ArchivedMessageEntry>;
}

export const EMPTY_MESSAGE_ARCHIVE: MessageArchiveDatabase = {
  version: MESSAGE_ARCHIVE_VERSION,
  entries: {},
};

export function archiveEntryKey(chatId: string, messageId: number) {
  return `${chatId}:${messageId}`;
}
